import React, { useState, useEffect, useCallback } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader/PageHeader';
import CustomTabPanel from '../../components/Tab/CustomTabPanel';
import WelcomeCampaignTab from './campaigns/WelcomeCampaignTab';
import LoyaltyCardTab from './campaigns/LoyaltyCardTab';
import PostSaleCampaignTab from './campaigns/PostSaleCampaignTab';
import PedidosYaCampaignTab from './campaigns/PedidosYaCampaignTab';
import CampaignService from '../../services/CampaignService';

const Campaigns = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  // Precargar configuraciones al entrar a la página
  const loadCampaignsConfig = useCallback(async () => {
    console.log('[Campaigns] Loading campaigns config - Starting...');
    try {
      // Cargar ambas configuraciones en paralelo
      const results = await Promise.all([
        CampaignService.getWelcomeCampaign().catch(err => {
          // Si no existe (404), no es un error crítico
          if (err.response?.status !== 404) {
            console.error('[Campaigns] Error loading welcome campaign:', err);
          } else {
            console.log('[Campaigns] Welcome campaign not found (404) - using defaults');
          }
          return null;
        }),
        CampaignService.getLoyaltyCardCampaign().catch(err => {
          // Si no existe (404), no es un error crítico
          if (err.response?.status !== 404) {
            console.error('[Campaigns] Error loading loyalty card campaign:', err);
          } else {
            console.log('[Campaigns] Loyalty card campaign not found (404) - using defaults');
          }
          return null;
        })
      ]);
      console.log('[Campaigns] Loading campaigns config - Completed:', {
        welcomeCampaign: results[0] ? 'loaded' : 'not found',
        loyaltyCardCampaign: results[1] ? 'loaded' : 'not found'
      });
    } catch (err) {
      console.error('[Campaigns] Error loading campaigns config:', err);
    }
  }, []);

  useEffect(() => {
    console.log('[Campaigns] Component mounted - Loading campaigns config');
    // Cargar configuraciones al montar la página
    loadCampaignsConfig();
  }, [loadCampaignsConfig]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="campaign tabs">
          <Tab label={t('welcome_campaign')} />
          <Tab label={t('loyalty_card_campaign')} />
          <Tab label="Post venta" />
          <Tab label="PedidosYa" />
        </Tabs>
      </Box>

      <CustomTabPanel value={tabValue} index={0}>
        <PageHeader title={t('welcome_campaign')} subtitle={t('welcome_campaign_subtitle')} />
        <WelcomeCampaignTab />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <PageHeader title={t('loyalty_card_campaign')} subtitle={t('loyalty_card_campaign_subtitle')} />
        <LoyaltyCardTab isActive={tabValue === 1} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={2}>
        <PageHeader title="Post venta" subtitle="Cupones impresos después de ventas locales elegibles" />
        <PostSaleCampaignTab />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={3}>
        <PageHeader title="PedidosYa" subtitle="Ticket promocional impreso en las ventas de PedidosYa" />
        <PedidosYaCampaignTab />
      </CustomTabPanel>
    </Box>
  );
};

export default Campaigns;
